const qrMfa = "/qr-mfa/";
const qrMfaConfirm = "/qrmfa-confirm/";
const qrMfaAuth = "/qrmfa-auth/";
const qrMfaEnable = "/qrmfa-enable/";
const url = "/user/";
const urlValidatePhone = "/validationphone/";
const urlConfirmationPhone = "/confirmationphone/";
const urlUpdatephone = "/updatephone/";
const urlTechnicalSupport = "/technical-support/";
export default {
  authQrMfa: (signature, axios, credentials) => {
    return axios
      .post(qrMfaAuth, credentials, {
        headers: { "X-SFC-Signature": signature(credentials) },
      })
      .then((response) => {
        if (response?.data?.error) {
          throw { response: { data: response.data } };
        } else {
          return { data: response.data };
        }
      })
      .catch((error) => {
        return { error: error?.response?.data || "Error" };
      });
  },  
  confirmQrMfa: (signature, axios, credentials) => {
    return axios
      .post(qrMfaConfirm, credentials, {
        headers: { "X-SFC-Signature": signature(credentials) },
      })
      .then((response) => {
        if (response?.data?.error) {
          throw { response: { data: response.data } };
        } else {
          return { data: response.data };
        }
      })
      .catch((error) => {
        return { error: error?.response?.data || "Error" };
      });
  }, 
    createTechnicalSupport(signature, axios, form, files) {
    let formComplaint = form;
    let formData = new FormData();
    let entries = Object.entries(formComplaint);
    Object.keys(formComplaint).forEach((key) => {
      form[key] = form[key] + "";
    });
    entries.forEach((entry) => {
      formData.append(entry[0], entry[1]);
    });
    files.anexesTechnicalSupport.forEach((file, index) => {
      formData.append(`document_file`, file);
    });    
    let sign = signature(formComplaint);
    return axios
      .post(urlTechnicalSupport, formData, {
        headers: { "X-SFC-Signature": sign },
      })
      .then((response) => ({ data: response.data }))
      .catch((error) => ({ error: error?.response?.data }));
  }, 
  signup: (signature, axios, form, files) => {
    Object.keys(form).forEach((key) => {
      form[key] = form[key] + "";
    });
    let sign = signature(form);
    let formData = new FormData();
    let entries = Object.entries(form);
    entries.forEach((entry) => {
      formData.append(entry[0], entry[1]);
    });
    files.forEach((file, index) => {
      formData.append(`file-${index}`, file);
    });

    return axios
      .post(url, formData, {
        headers: {
          "X-SFC-Signature": sign,
        },
      })
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => {
        return { error: error?.response?.data || "Error" };
      });
  },
  existPhoneOnDB: (signature, axios, form) => {
    let sign = signature(form);
    return axios
      .post(urlValidatePhone, form, {
        headers: {
          "X-SFC-Signature": sign,
        },
      })
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => {
        return { error: error?.response?.data || "Error" };
      });
  },
  isConfirmedPhone: (signature, axios, form) => {
    let sign = signature(form);
    return axios
      .put(urlConfirmationPhone, form, {
        headers: {
          "X-SFC-Signature": sign,
        },
      })
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => {
        return { error: error?.response?.data || "Error" };
      });
  },
  generateQrMfa: (signature, axios, credentials) => {
    return axios
      .post(qrMfa, credentials, {
        headers: { "X-SFC-Signature": signature(credentials) },
      })
      .then((response) => {
        if (response?.data?.error) {
          throw { response: { data: response.data } };
        } else {
          return { data: response.data };
        }
      })
      .catch((error) => {
        return { error: error?.response?.data || "Error" };
      });
  },
  getUser: (axios, id) => {
    return axios
      .get(`${url + id}/`)
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => {
        return { error: error?.response?.data };
      });
  },
  modifyEnableQr: (signature, axios, credentials) => {
    return axios
      .post(qrMfaEnable, credentials, {
        headers: { "X-SFC-Signature": signature(credentials) },
      })
      .then((response) => {
        if (response?.data?.error) {
          throw { response: { data: response.data } };
        } else {
          return { data: response.data };
        }
      })
      .catch((error) => {
        return { error: error?.response?.data || "Error" };
      });
  },
  updateUserPassword: (signature, axios, id, user) => {
    return axios
      .patch(`${url}detail/${id}`, user, {
        headers: {
          "X-SFC-Signature": signature(user),
        },
      })
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => {
        return { error: error?.response?.data };
      });
  },
  updateUserPhone: (signature, axios, form) => {
    let sign = signature(form);
    return axios
      .put(urlUpdatephone, form, {
        headers: {
          "X-SFC-Signature": sign,
        },
      })
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => {
        return { error: error?.response?.data || "Error" };
      });
  },
  updateUserProfile: (signature, axios, id, user) => {
    return axios
      .put(`/profile/${id}/`, user, {
        headers: {
          "X-SFC-Signature": signature(user),
        },
      })
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => {
        return { error: error.response?.data };
      });
  },
};
